import { GETTSTEMPLATE_SUCCESS, GETTSTEMPLATE_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const getTsTemplateReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETTSTEMPLATE_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETTSTEMPLATE_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default getTsTemplateReducer;
